<template>
  <div class="shopIndex">
    <a-carousel arrows autoplay dotsClass="dots" class="carousel">
      <div v-for="(item,i) in banner" :key="i" class="image-container">
        <img :src="item.img_url">
      </div>
    </a-carousel>
    <div class="shopLogo" v-for="(item,i) in teban" :key="i">
      <img :src="item.img_url">
    </div>
    <div class="indexBody">
      <div>
        <div class="leftBox" v-if="detail.title">
          <div>
            <div class="logoBox">
              <img :src="detail.logo==''?require('@/assets/cloud_shop.png'):detail.logo">
            </div>
            <div></div>
            <div>{{ detail.title }}</div>
            <div>
              <div><span>{{detail.ying}}</span>年</div>
              <!-- <div>{{detail.ying}}</div> -->
              <img :class="item.index==1?'':'wanshang'"  v-for="(item,i) in detail.brand" :key="i" :src="item.url">
            </div>
            <div>
              <div>认证信息：</div>
              <img src="@/assets/rzxx.png">
            </div>
            <div>
              <div>经营执照：</div>
              <img src="@/assets/yyzz_icon.png">
            </div>
            <div>
              <div>社会统一代码：</div>
              <div>{{ detail.enterprise.code }}</div>
            </div>
            <div class="btnBox">
              <a-button type="primary" @click="toShop">进入店铺</a-button>
              <a-button type="primary" ghost @click="allGoods">全部商品</a-button>
            </div>
            <!-- <a-divider />
            <div class="scoreBox">
              <img src="@/assets/score.png">
              <div>
                <div>
                  <div>{{detail.pf_spff}}</div>
                  <div>商品<br>丰富</div>
                </div>
                <div>
                  <div>{{detail.pf_ksxy}}</div>
                  <div>快速<br>响应</div>
                </div>
                <div>
                  <div>{{detail.pf_gylzc}}</div>
                  <div>供应链<br>支持</div>
                </div>
                <div>
                  <div>{{detail.pf_ghwd}}</div>
                  <div>供货<br>稳定</div>
                </div>
              </div>
              <div>参与评分<span class="iconfont icon-right"></span></div>
            </div> -->
          </div>
          <div>
            <div>商品分类</div>
            <div class="goodsCollapse">
              <a-collapse :defaultActiveKey="0" expandIconPosition="right">
                <a-collapse-panel v-for="(item,i) in types" :key="i" :showArrow="item.children.length>0" :disabled="item.children.length===0">
                  <div slot="header" :style="activeId==item.id?{color:'var(--default)'}:{}" @click="collapseChange(item.children.length,item.id)">
                    {{ item.title }}
                  </div>
                  <p :style="activeId==child.id?{color:'var(--default)'}:{}" v-for="child in item.children" :key="child.id" @click="collapseChange(0,child.id)">{{ child.title }}</p>
                </a-collapse-panel>
              </a-collapse>
            </div>
          </div>
          <div>
            <div>供应商品</div>
            <router-link :to="{ path: '/goodsDetail', query: { id: item.id } }" v-for="(item,i) in supplyGoods" :key="i">
              <div class="image-container">
                <img class="play-icon" src="@/assets/play.png" v-if="item.video_type==1">
                <img :src="item.main_image">
              </div>
              <div>
                <div>{{item.product_title}}</div>
                <div>￥ {{ item.price }}</div>
              </div>
            </router-link>
            <div style="padding: 10px 0;color:#999;" v-if="supplyGoods.length===0">暂无商品</div>
            <div @click="allGoods">查看更多产品</div>
          </div>
          <div>
            <div>联系方式</div>
            <div v-if="detail.person">
              <div>联系人</div>
              <div>{{detail.person}}</div>
            </div>
            <div v-if="detail.post">
              <div>职务</div>
              <div>{{detail.post}}</div>
            </div>
            <div v-if="detail.phone">
              <div>公司电话</div>
              <div>{{detail.phone}}</div>
            </div>
            <div v-if="detail.email">
              <div>邮箱</div>
              <div>{{detail.email}}</div>
            </div>
            <div v-if="detail.fax">
              <div>传真</div>
              <div>{{detail.fax}}</div>
            </div>
            <div v-if="detail.address">
              <div>公司地址</div>
              <div>{{detail.city_str+detail.address}}</div>
            </div>
          </div>
        </div>
        <div class="rightBox">
          <div class="title">推荐商品</div>
          <div class="noResult" v-show="!goodsLoading&&list.length===0">
            <div>
              <img src="@/assets/nothing.png">
            </div>
            <div>
              <div>
                <div>店铺还未上传商品</div>
                <!-- <div>抱歉，未找到包含“<span>{{ title }}</span>”的<span>{{ type }}</span>信息</div> -->
              </div>
              <div>建议您： <br>1、等待店铺上传商品后再进行查看 <br>2、咨询客服</div>
              <div>
                <a-button class="zhiCustomBtn" shape="round" type="danger">
                  去咨询
                </a-button>
              </div>
            </div>
          </div>
          <a-spin v-show="list.length>0" :spinning="goodsLoading">
            <a-icon slot="indicator" type="loading" style="font-size: 24px" spin />
            <div class="goodsList">
              <router-link :to="{ path: '/goodsDetail', query: { id: item.id } }" v-for="(item,i) in list" :key="i" class="goodsItem">
                <div class="image-container">
                  <img class="play-icon" src="@/assets/play.png" v-if="item.video_type==1">
                  <img :src="item.video_image?item.video_image:(item.main_image?item.main_image:require('@/assets/goods_default.png'))">
                </div>
                <div><span v-if="item.price">￥</span>{{ item.price?item.price:'待议价' }}</div>
                <div>{{ item.product_title }}</div>
              </router-link>
              <a v-if="list.lenght%4==1">
              </a>
              <a v-if="list.lenght%4==2">
              </a>
            </div>
          </a-spin>
          <!-- <div class="title">企业资质</div>
          <div v-if="detail.enterprise.authorize_letter" class="image-container">
            <img :src="baseUrl+detail.enterprise.authorize_letter">
          </div>
          <div v-if="detail.enterprise.business_license" class="image-container">
            <img :src="baseUrl+detail.enterprise.business_license">
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "shopIndex",
  props: {
    detail: Object,
    list: Array,
    banner: Array,
    types: Array,
    teban: Array,
    goodsLoading: Boolean,
    supplyGoods: Array,
  },
  computed: {
    baseUrl() {
      return this.$store.state.baseUrl;
    },
  },
  data: function () {
    return {
      activeId: null,
    };
  },
  methods: {
    toShop() {
      this.$emit("toShop");
    },
    allGoods() {
      this.activeId = null;
      this.$emit("allGoods");
      // window.scrollTo(0, 0);
    },
    collapseChange(length, id) {
      if (length === 0) {
        this.$emit("collapseChange", [id]);
        this.activeId = id;
      }
    },
    initService(){
      const obj=document.getElementsByClassName("zhiCustomBtn");
      for(let i=0;i<obj.length;i++){
        obj[i].onclick=function(){
          // eslint-disable-next-line no-undef
          zc("dynamic_ready")
        }
      }
    },
  },
  mounted: function () {
    this.initService();
  },
};
</script>
<style lang="less">
@media screen and (min-width: 1025px) {
  .shopIndex {
    width: 100%;
    min-width: 1200px;
    overflow: hidden;
    display:flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .carousel {
      font-size: 0;
      width: 100%;
      min-width: 1200px;
      max-width: 1920px;
      height: auto;
      text-align: center;
      img {
        width: 100%;
        min-width: 1200px;
        height: auto;
      }
    }
    .shopLogo {
      width: 100%;
      min-width: 1200px;
      height: auto;
      > img {
        max-width: 100%;
        height: 100%;
      }
    }
    .goodsCollapse {
      .ant-collapse {
        .ant-collapse-item-disabled {
          .ant-collapse-header {
            cursor: pointer;
            color: #333;
          }
        }
      }
    }
    .indexBody {
      width: 100%;
      min-width: 1200px;
      overflow: hidden;
      background-color: #f1f1f1;
      > div {
        width: 1200px;
        padding: 40px 0;
        display: inline-flex;
        justify-content: space-between;
        > .leftBox {
          > div:first-child {
            width: 260px;
            // height: 540px;
            background-color: #fff;
            border-radius: 4px;
            text-align: center;
            padding: 20px;
            .logoBox {
              background-image: linear-gradient(
                18deg,
                #d03d3c 11%,
                #f3c2c2 87%
              );
              padding: 2px;
              width: 64px;
              height: 64px;
              border-radius: 50%;
              margin-right: 20px;
              display:inline-block;
              img {
                width: 100%;
                height: 100%;
                border-radius: 50%;
              }
            }
            > div:nth-child(2) {
              font-size: 12px;
            }
            > div:nth-child(3) {
              font-size: 16px;
              font-weight: 600;
              margin: 24px 0;
              width:196px;
              text-align:center;
              white-space: pre-wrap;
              word-break: break-all;
              display:inline-block;
            }
            > div:nth-child(4) {
              display: flex;
              align-items: center;
              flex-wrap: wrap;
              margin-bottom: 15px;
              > div {
                font-size: 14px;
                color: #333;
                margin-right: 20px;
                white-space: nowrap;
                span {
                  font-size: 24px;
                  font-weight: 600;
                  color: var(--default);
                }
              }
              img {
                width: auto;
                height: 35px;
                margin-right:5px;
              }
              .wanshang {
                height:20px;
              }
            }
            > div:nth-child(5),
            > div:nth-child(6),
            > div:nth-child(7) {
              display: flex;
              height: 17px;
              line-height: 17px;
              margin-bottom: 15px;
              white-space: nowrap;
              > div:first-child {
                font-size: 12px;
                color: #999;
              }
              img {
                width: 20px;
                height: 20px;
              }
            }
            .btnBox {
              padding-top: 9px;
              display: flex;
              justify-content: space-between;
              button {
                width: 100px;
                height: 32px;
                border-radius: 16px;
              }
            }
            .ant-divider {
              margin: 14px 0;
            }
            .scoreBox {
              height: 120px;
              display: flex;
              flex-direction: column;
              justify-content: space-between;
              img {
                width: 134px;
                height: 20px;
              }
              > div:nth-child(2) {
                display: flex;
                justify-content: space-between;
                > div {
                  > div:first-child {
                    font-size: 18px;
                  }
                  > div:last-child {
                    font-size: 12px;
                    color: #999;
                  }
                }
              }
              > div:last-child {
                height: 20px;
                line-height: 20px;
                color: var(--default);
              }
            }
          }
          > div:nth-child(3){
            width: 260px;
            background-color: #fff;
            border-radius: 4px;
            text-align: center;
            padding: 20px;
            margin-top: 20px;
            > div:first-child {
              font-size: 18px;
              font-weight: 600;
              text-align: left;
              margin-bottom: 20px;
              color:#333;
            }
            > a:not(:first-child) {
              display: flex;
              align-items: center;
              justify-content: space-between;
              font-size: 12px;
              text-align: left;
              margin-bottom: 20px;
              cursor: pointer;
              color:#333;
              .image-container {
                width: 74px;
                height: 74px;
                position: relative;
                img {
                  width: 100%;
                  height: 100%;
                }
                .play-icon{
                  width: 25px;
                  height: 25px;
                  position: absolute;
                  top: 50%;
                  left: 50%;
                  transform: translate(-50%, -50%);
                }
              }
              > div:last-child {
                color:#333;
                width: calc(100% - 84px);
                > div:first-child {
                  display: -webkit-box;
                  -webkit-box-orient: vertical;
                  -webkit-line-clamp: 2;
                  overflow: hidden;
                }
                > div:last-child {
                  color: var(--default);
                }
              }
            }
            > div:last-child {
              margin-bottom: 0;
              height: 44px;
              justify-content: center;
              line-height: 44px;
              cursor: pointer;
              border-top: 1px solid #e1e1e1;
            }
          }
          > div:nth-child(2) {
            width: 260px;
            background-color: #fff;
            border-radius: 4px;
            text-align: center;
            padding: 20px;
            margin-top: 20px;
            > div:first-child {
              font-size: 18px;
              font-weight: 600;
              text-align: left;
              margin-bottom: 20px;
            }
            .ant-collapse-item {
              text-align: left;
              background-color: #fff;
              border-bottom: 1px dashed #ccc;
            }
            .ant-collapse {
              border: none;
              > .ant-collapse-item:last-child {
                border-bottom: none;
              }
            }
            .ant-collapse-item-active {
              border-bottom: none;
            }
            .ant-collapse-content-active,
            .ant-collapse-content {
              border-top: none;
            }
            .ant-collapse-content-box {
              p {
                margin-bottom: 10px;
                padding-left: 10px;
              }
              p:hover {
                cursor: pointer;
                color: var(--default);
              }
            }
          }
          > div:last-child {
            width: 260px;
            background-color: #fff;
            border-radius: 4px;
            text-align: center;
            padding: 20px;
            margin-top: 20px;
            > div:first-child {
              font-size: 18px;
              font-weight: 600;
              text-align: left;
              margin-bottom: 20px;
            }
            > div:not(:first-child) {
              display: flex;
              align-items: flex-start;
              font-size: 12px;
              text-align: left;
              margin-bottom: 12px;
              > div:first-child {
                width: 72px;
                color: #999999;
              }
              > div:last-child {
                width: calc(100% - 72px);
                white-space: pre-wrap;
                word-break: break-all;
                word-wrap: break-word;
              }
            }
          }
        }
        > .rightBox {
          width: 920px;
          .title {
            text-align: left;
            font-size: 24px;
            font-weight: 600;
            color: #000;
            padding-bottom: 13px;
            display: flex;
            align-items: center;
            border-bottom: 1px solid #e1e1e1;
          }
          .title::before {
            content: "";
            display: inline-block;
            width: 4px;
            height: 26px;
            background-color: var(--default);
            margin-right: 10px;
          }
          .goodsList {
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
            align-content: space-between;
            margin-bottom: 40px;
            > a {
              height: 285px;
              width: 212px;
              margin-top: 24px;
              text-align: left;
              display: flex;
              flex-direction: column;
              justify-content: space-between;
              cursor: pointer;
              color: #333;
              .image-container{
                width: 212px;
                text-align: center;
                border-radius: 8px;
                img {
                  width: auto;
                  height: 212px;
                }
                .play-icon{
                  width: 40px;
                  height: 40px;
                  position: absolute;
                  top: 50%;
                  left: 50%;
                  transform: translate(-50%, -50%);
                }
              }
              > div:nth-child(2) {
                font-size: 18px;
                font-weight: 500;
                color: #f11046;
              }
              > div:last-child {
                font-size: 14px;
                font-weight: 400;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
              }
            }
            > a:last-child:nth-child(4n - 2) {
              margin-right: 50%;
            }
            > a:last-child:nth-child(4n - 1) {
              margin-right: 25%;
            }
          }
          > div:last-child {
            margin-top: 20px;
            img {
              width: 212px;
              height: 212px;
            }
          }
          .image-container {
            img {
              max-width: 100%;
            }
          }
        }
      }
    }
    .ant-carousel .slick-slide {
      text-align: center;
      background: #364d79;
      overflow: hidden;
    }

    .ant-carousel .custom-slick-arrow {
      width: 30px;
      height: 56px;
      font-size: 25px;
      color: #fff;
      background-color: rgba(0, 0, 0, 0.5);
      opacity: 1;
      display: inline-flex !important;
      justify-content: center !important;
      align-items: center !important;
    }
    .ant-carousel .custom-slick-arrow:before {
      display: none;
    }

    .ant-carousel .custom-slick-arrow:hover {
      opacity: 0.7;
    }

    .ant-carousel .slick-slide span {
      color: #fff;
    }

    .dots {
      bottom: 30px;
    }

    .dots li {
      background-color: rgba(51, 51, 51, 0.2);
      padding: 4px 3px;
      margin: 0;
    }
    .dots li button {
      width: 8px;
      height: 8px;
      margin: 0 2px;
      border-radius: 100px;
    }
    .dots .slick-active button {
      width: 32px !important;
    }

    .dots li:first-child {
      padding-left: 4px;
      border-top-left-radius: 100px;
      border-bottom-left-radius: 100px;
    }

    .dots li:last-child {
      padding-right: 4px;
      border-top-right-radius: 100px;
      border-bottom-right-radius: 100px;
    }
    .noResult {
      margin: 50px 0;
      width: 100%;
      display: flex;
      justify-content: center;
      > div:first-child {
        margin-right: 40px;
        img {
          width: 250px;
          height: 250px;
        }
      }
      > div:last-child {
        display: flex;
        justify-content: space-between;
        flex-direction: column;
        font-size: 16px;
        color: #666;
        text-align:left;
        > div:first-child {
          > div:first-child {
            font-size: 24px;
            color: #333;
          }
          > div:last-child {
            margin-top: 13px;
            span:first-child {
              color: var(--default);
            }
          }
        }
        > div:nth-child(2) {
          line-height: 32px;
        }
        > div:last-child {
          button {
            width: 104px;
            height: 33px;
            background-color: var(--default);
          }
        }
      }
    }
  }
  .shopIndex::-webkit-scrollbar {
    display: none;
  }
}
@media screen and (max-width: 1024px) {
  .shopIndex {
    width: 100%;
    max-width: 100%;
    overflow: hidden;
    .carousel {
      display: none;
      // font-size: 0;
      // max-width: 100%;
      // height: auto;
      // text-align: center;
      // img {
      //   max-width: 100%;
      //   height: auto;
      // }
    }
    .shopLogo {
      display: none;
      // width: 100%;
      // height: auto;
      // > img {
      //   width: 100%;
      //   height: 100%;
      // }
    }
    .goodsCollapse {
      .ant-collapse {
        .ant-collapse-item-disabled {
          .ant-collapse-header {
            cursor: pointer;
            color: #333;
          }
        }
      }
    }
    .indexBody {
      width: 100%;
      overflow: hidden;
      background-color: #f1f1f1;
      > div {
        width: 100%;
        padding: 12px 0;
        display: inline-flex;
        justify-content: space-between;
        > .leftBox {
          display: none;
        }
        > .rightBox {
          width: 100%;
          .title {
            display: none;
          }
          .title::before {
            content: "";
            display: inline-block;
            width: 4px;
            height: 26px;
            background-color: var(--default);
            margin-right: 10px;
          }
          .goodsList {
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
            align-content: space-between;
            margin-bottom: 40px;
            padding: 0 12px;
            > a {
              width: calc((100vw - 36px) / 2);
              margin-bottom: 12px;
              text-align: left;
              display: flex;
              flex-direction: column;
              justify-content: space-between;
              cursor: pointer;
              color: #333;
              .image-container{
                position:relative;
                width: 100%;
                border-radius: 8px;
                text-align: center;
                img {
                  width:auto;
                  height: calc((100vw - 36px) / 2);
                }
                .play-icon{
                  width: 40px;
                  height: 40px;
                  position: absolute;
                  top: 50%;
                  left: 50%;
                  transform: translate(-50%, -50%);
                }
              }
              > div:nth-child(2) {
                margin-top: 8px;
                font-size: 16px;
                font-weight: 500;
                color: #f11046;
              }
              > div:last-child {
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
              }
            }
          }
          > div:last-child {
            img {
              width: 100%;
              height: calc((100vw - 36px) / 2);
            }
          }
          .image-container {
            img {
              max-width: 100%;
            }
          }
        }
      }
    }
    .ant-carousel .slick-slide {
      text-align: center;
      background: #364d79;
      overflow: hidden;
    }

    .ant-carousel .custom-slick-arrow {
      width: 30px;
      height: 56px;
      font-size: 25px;
      color: #fff;
      background-color: rgba(0, 0, 0, 0.5);
      opacity: 1;
      display: inline-flex !important;
      justify-content: center !important;
      align-items: center !important;
    }
    .ant-carousel .custom-slick-arrow:before {
      display: none;
    }

    .ant-carousel .custom-slick-arrow:hover {
      opacity: 0.7;
    }

    .ant-carousel .slick-slide span {
      color: #fff;
    }

    .dots {
      bottom: 30px;
    }

    .dots li {
      background-color: rgba(51, 51, 51, 0.2);
      padding: 4px 3px;
      margin: 0;
    }
    .dots li button {
      width: 8px;
      height: 8px;
      margin: 0 2px;
      border-radius: 100px;
    }
    .dots .slick-active button {
      width: 32px !important;
    }

    .dots li:first-child {
      padding-left: 4px;
      border-top-left-radius: 100px;
      border-bottom-left-radius: 100px;
    }

    .dots li:last-child {
      padding-right: 4px;
      border-top-right-radius: 100px;
      border-bottom-right-radius: 100px;
    }
    .noResult {
      margin: 50px 0;
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      text-align: center;
      > div:first-child {
        width: 150px;
        height: 150px;
        margin-bottom:20px;
        img {
          width: 150px;
          height: 150px;
        }
      }
      > div:last-child {
        display: flex;
        justify-content: space-between;
        flex-direction: column;
        font-size: 16px;
        color: #666;
        > div:first-child {
          text-align: center;
          > div:first-child {
            font-size: 24px;
            color: #333;
          }
          > div:last-child {
            margin-top: 13px;
            span:first-child {
              color: var(--default);
            }
          }
        }
        > div:nth-child(2) {
          line-height: 32px;
        }
        > div:last-child {
          button {
            width: 104px;
            height: 33px;
            background-color: var(--default);
          }
        }
      }
    }
  }
  .shopIndex::-webkit-scrollbar {
    display: none;
  }
}
</style>